import { Layout, Row } from "antd";
import { Content } from "antd/lib/layout/layout";
import dayjs from "dayjs";
import { useState } from "react";
import BarChart from "./components/BarChart";
import BestSellingCategories from "./components/BestSellingCategories";
import BestSellingProducts from "./components/BestSellingProducts";
import CardsStats from "./components/CardsStats";
import LatestModifiedDocs from "./components/LatestModifiedDocs";
import LineChart from "./components/LineChart";
import PieChart from "./components/PieChart";
import PriorityTasks from "./components/PriorityTasks";
import TemplateChangedModal from "./components/TemplateChangedModal";
import WelcomeCard from "./components/WelcomeCard";
import useDashboardPreferencesStore from "./store/useDashboardPreferencesStore";

export default function Dashboard() {
  const [startDate, setStartDate] = useState(dayjs().subtract(2, "month").startOf("month"));
  const [endDate, setEndDate] = useState(dayjs());

  const { widgets } = useDashboardPreferencesStore();

  const sortedWidgets = [...widgets].sort((a, b) => a.order - b.order);

  const renderWidget = (widgetId: string) => {
    const widget = widgets.find(w => w.id === widgetId);
    if (!widget || !widget.visible) return null;

    switch (widgetId) {
      case "cardsStats":
        return <CardsStats key={widgetId} />;
      case "priorityTasks":
        return <PriorityTasks key={widgetId} />;
      case "latestModifiedDocs":
        return <LatestModifiedDocs key={widgetId} />;
      case "lineChart":
        return (
          <LineChart
            key={widgetId}
            endDate={endDate}
            startDate={startDate}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
          />
        );
      case "pieChart":
        return <PieChart key={widgetId} startDate={startDate} endDate={endDate} />;
      case "barChart":
        return <BarChart key={widgetId} startDate={startDate} endDate={endDate} />;
      case "bestSellingCategories":
        return <BestSellingCategories key={widgetId} startDate={startDate} endDate={endDate} />;
      case "bestSellingProducts":
        return <BestSellingProducts key={widgetId} startDate={startDate} endDate={endDate} />;
      default:
        return null;
    }
  };

  return (
    <Layout className="layout-card dashboard">
      <Content className="layout-card-content-full">
        <WelcomeCard />
        <CardsStats />
        <Row gutter={[24, 24]}>
          {sortedWidgets
            .filter(widget => widget.id !== "cardsStats" && widget.visible)
            .map(widget => renderWidget(widget.id))}
        </Row>
      </Content>
      <TemplateChangedModal />
    </Layout>
  );
}
